module.exports = __webpack_public_path__ + "img/inno_3.614c3671.png";